import { PreferencesRepository } from "./adapters/preferencesRepository";

import * as retrievePreferences from "./useCases/retrievePreferences";
import * as editPreferences from "./useCases/editPreferences";

enum UseCases {
  retrievePreferences = "retrievePreferences",
  editPreferences = "editPreferences",
}

interface Core {
  [UseCases.retrievePreferences]: retrievePreferences.Interactor;
  [UseCases.editPreferences]: editPreferences.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  preferencesRepository: PreferencesRepository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrievePreferences]: retrievePreferences.createInteractor(
      dependencies.preferencesRepository,
    ),
    [UseCases.editPreferences]: editPreferences.createInteractor(
      dependencies.preferencesRepository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
